module.exports = __webpack_public_path__ + "ab100a193cb4d4379feda478da5dc486.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/Help/screenshots/Wizard Page (4).png
// module id = 1047
// module chunks = 0